import { Alert, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { joinMembershipPath, learnerSchedulePath } from "@outschool/routes";
import SectionCls from "@outschool/section";
import { useSession } from "@outschool/ui-auth";
import { Container } from "@outschool/ui-legacy-component-library";
import { compact } from "lodash";
import React from "react";

import { useWaitlistSeatsForParentQuery } from "../../queries/WaitlistQuery";
import { TabType, ViewType } from "../../routes/ParentSchedulePage";
import Link from "../Link";

const Section = new SectionCls();

export default function AvailableSeatsFromWaitlistBanner() {
  const { t } = useTranslation(
    "client\\components\\loggedInHome\\LoggedInHomeMyClassesList"
  );

  const { currentUser } = useSession();

  const { waitlistSeats } = useWaitlistSeatsForParentQuery({
    parentUid: currentUser?.uid
  });

  const hasOpenSeats = React.useMemo(
    () =>
      compact(waitlistSeats).some(
        ws => !!Section.publicallyAvailableSpaces(ws.section)
      ),
    [waitlistSeats]
  );

  if (!hasOpenSeats) {
    return null;
  }

  return (
    <Container size="medium" sx={{ marginTop: "2.4rem", width: "100%" }}>
      <Alert
        severity="info"
        title={t("Seats have opened up for your waitlisted classes")}
      >
        <Typography>
          <Trans t={t}>
            You can check your waitlisted classes in{" "}
            <Link
              to={learnerSchedulePath(ViewType.Classes, TabType.Waitlisted)}
            >
              {t("All Classes")}
            </Link>
            .{" "}
            <Link
              trackingName="AvailableSeatsFromWaitlistBannerToJoinMembership"
              to={joinMembershipPath()}
            >
              Members
            </Link>{" "}
            have 24 hours to enroll before non-members.
          </Trans>
        </Typography>
      </Alert>
    </Container>
  );
}
